// Unpublished Work © 2021-2022 Deere & Company

import {SET_CUSTOMER_IDS} from '../action-list';

export const setCustomerIds = (entityId, contactId) => ({
    customerIds: {
        contactId,
        entityId
    },
    type: SET_CUSTOMER_IDS
});

export const setCustomerIdsAndNavigate = ({
    contactId,
    entityId,
    historyPush,
    route
}) => (dispatch) => {
    dispatch(setCustomerIds(entityId, contactId));
    historyPush(route);
};
